<template>
    <div class="">
        <div class="flex justify-center mb-6">
            <button
                class="flex items-center mt-6 font-normal text-center text-blue-500"
                @click="back"
            >
                {{ practitionerName }}

                <!-- prettier-ignore -->
                <svg class="ml-2" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-label="">
                <path d="M14.7499 4.16774C14.7505 4.07562 14.7328 3.9843 14.698 3.89902C14.6632 3.81374 14.6118 3.73618 14.547 3.67077L11.5792 0.702997C11.5138 0.638124 11.4362 0.586801 11.3509 0.551968C11.2657 0.517135 11.1743 0.499479 11.0822 0.500012C10.9901 0.499479 10.8988 0.517135 10.8135 0.551968C10.7282 0.586801 10.6507 0.638124 10.5853 0.702997L8.6044 2.68385L0.953973 10.3343C0.889101 10.3997 0.837777 10.4772 0.802945 10.5625C0.768112 10.6478 0.750456 10.7391 0.750988 10.8312V13.799C0.750988 13.9847 0.824733 14.1627 0.955998 14.294C1.08726 14.4252 1.2653 14.499 1.45094 14.499H4.41871C4.51666 14.5043 4.61462 14.489 4.70627 14.454C4.79791 14.419 4.88118 14.3652 4.95067 14.296L12.5591 6.64555L14.547 4.6997C14.6108 4.63186 14.6629 4.55378 14.7009 4.46872C14.7077 4.41292 14.7077 4.35652 14.7009 4.30073C14.7042 4.26815 14.7042 4.23532 14.7009 4.20273L14.7499 4.16774ZM4.13174 13.0991H2.15088V11.1182L9.10137 4.16774L11.0822 6.14859L4.13174 13.0991ZM12.0691 5.16166L10.0883 3.18081L11.0822 2.19389L13.0561 4.16774L12.0691 5.16166Z" fill="#004876"/>
                </svg>
            </button>
        </div>

        <p v-if="noAppointments" class="text-blue-500">
            We're sorry, there are no appointents available with this practitioner. Please choose
            another practitioner.
        </p>

        <template v-else>
            <BaseLabel v-if="appointmentsByPractitioner.length" class="mt-5" text="Date">
                <DateCarousel
                    :appointments="appointmentsByPractitioner"
                    :preferred-date="preferredDate"
                    :is-loading="isLoading"
                    @select="$emit('update:preferredDate', $event)"
                />
            </BaseLabel>

            <transition name="slide" mode="out-in">
                <BaseLabel v-if="preferredDate && practitionerId" class="mt-5" text="Appointments">
                    <p
                        class="mb-1 text-center bg-blue-100 rounded-t rounded-t-xl small text-grey-500"
                    >
                        {{ preferredDateFormatted }}
                    </p>
                    <div class="flex flex-wrap -mx-1">
                        <div
                            v-for="(option, index) in filteredAppointments"
                            :key="index"
                            class="w-1/3 px-1 my-1"
                        >
                            <BaseRadio
                                :active="appointmentId && option.appointmentId == appointmentId"
                                :value="option.appointmentId"
                                :text="formatTime(option.appointmentTime)"
                                :disabled="isLoading"
                                @input="$emit('select-appointment', $event)"
                            />
                        </div>
                    </div>
                </BaseLabel>
            </transition>
        </template>

        <button v-if="noAppointments" class="w-full mt-10 btn exception" @click="back">
            Back
        </button>

        <!-- <button
            v-else
            class="w-full mt-10 btn exception"
            :disabled="$v.$invalid"
            :class="{
                'btn--ghost-grey opacity-75': $v.$invalid && !isLoading,
                'btn--loading text-transparent': isLoading
            }"
            @click="!isLoading && $emit('next')"
        >
            Continue
        </button>  -->
    </div>
</template>

<script>
import { DateTime } from 'luxon';
import { toTimeString } from '@/../vue/online-booking/utils/dates';
import ServiceTypeUtils from '@/../vue/online-booking/mixins/service-type-utils';
import appointmentFilters from '@/../vue/online-booking/mixins/appointment-filters';
import { required } from 'vuelidate/lib/validators';
import BaseLabel from '@/../vue/_base/form/Label.vue';
import DateCarousel from '@/../vue/online-booking/components/DateCarousel.vue';
import BaseRadio from '@/../vue/_base/form/Radio.vue';

export default {
    components: {
        BaseLabel,
        BaseRadio,
        DateCarousel
    },

    mixins: [ServiceTypeUtils, appointmentFilters],

    props: {
        practitioners: {
            type: Array,
            required: true
        },
        appointments: {
            type: Array,
            required: true
        },
        appointmentId: {
            type: Number,
            default: null
        },
        practitionerId: {
            type: Number,
            default: null
        },
        preferredDate: {
            type: String,
            default: null
        },
        serviceType: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },

    computed: {
        practitionerName() {
            const practitioner = this.practitioners.find(
                (p) => p.employeeId === this.practitionerId
            );
            return `${practitioner.firstName} ${practitioner.surname}`;
        },
        preferredDateFormatted() {
            return (
                this.preferredDate &&
                DateTime.fromFormat(this.preferredDate, 'd/M/yy').toFormat('cccc d, MMMM yyyy')
            );
        },
        noAppointments() {
            return !this.isLoading && !this.appointmentsByPractitioner.length;
        }
    },

    watch: {
        $v: {
            handler() {
                if (!this.$v.$invalid) {
                    this.$emit('next');
                }
            },
            deep: true
        }
    },

    methods: {
        formatTime(string) {
            return toTimeString(string);
        },
        back() {
            this.$emit('reset-practitioner');
            this.$emit('back');
        }
    },

    validations: {
        preferredDate: {
            required
        },
        appointmentId: {
            required
        }
    }
};
</script>
